import React from 'react'
import DepartmentSelectMain from '../../../../form/fields/DepartmentSelectMain'
import { useState } from 'react'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { checkPersonInDepartmentAPI } from '../../../../../api/department/departmentAPI'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MySpiner from '../../../../UI/spiner/MySpiner'

const WriteOffActDepartmentSelect = ({ required, setValidate, setValueForm, forciblyValue, withoutType, setItems }) => {

    const [value, setValue] = useState(forciblyValue)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const checkPersonInDepartment = (departmentId) => {
        if (departmentId) {
            setError('')
            setLoading(true)
            setItems([]) // Обнуляємо позиції завжди при зміні підрозділу
            checkPersonInDepartmentAPI({ departmentId, type: 'writeOff' }).then(data => {
                setValue(departmentId)
                setValueForm(departmentId)
                setValidate(true)
                setLoading(false)
            }).catch(e => {
                setValue('')
                setValueForm('')
                // setValidate(false)
                setValidate(false)
                setError(responseError(e))
                setLoading(false)
            })
        }
	}

  return (
    <>
        <DepartmentSelectMain
            // departmentTypeId={data.departmentTypeId}
            required={required}
            setValidate={e => {
                setValidate(e)
            }}
            setValueForm={e => {
                checkPersonInDepartment(e)
                // setValueForm(e)
            }}
            // forciblyValue={forciblyValue}
            forciblyValue={value}
            forciblyError={error}
            withoutType={withoutType}
        />
        {
            loading ? <MySpiner /> : ''
        }
        <ErrorMessage error={error} />
    </>
  )
}

export default WriteOffActDepartmentSelect